import { createSlice } from '@reduxjs/toolkit';


const loadAddressFromLocalStorage = () => {
  const savedAddress = localStorage.getItem('selectedAddress');
  const isSelectedAddress = localStorage.getItem('isSelectedAddress');
  return {
    selectedAddress: savedAddress ? JSON.parse(savedAddress) : "",
    isSelectedAddress: isSelectedAddress || false,
  };
};

const selectedAddressSlice = createSlice({
  name: 'selectedAddress',
  initialState: loadAddressFromLocalStorage(),
  checkboxChecked:false,
  reducers: {
    setSelectedAddress: (state, action) => {
      const newAddress = action.payload;
      state.selectedAddress = newAddress;
      state.isSelectedAddress = true;
      
      
      localStorage.setItem('selectedAddress', JSON.stringify(newAddress));
      localStorage.setItem('isSelectedAddress', 'true');
    },
    clearSelectedAddress: (state) => {
      state.selectedAddress = "";
      state.isSelectedAddress = false;
      
      localStorage.removeItem('selectedAddress');
      localStorage.setItem('isSelectedAddress', 'false');
    },
    setCheckboxChecked:(state, action)=>{
      state.checkboxChecked = action.payload;
    }
  },
});

export const { setSelectedAddress, clearSelectedAddress, setCheckboxChecked } = selectedAddressSlice.actions;


export const selectSelectedAddress = (state) => state.selectedAddress.selectedAddress;
export const selectIsSelectedAddress = (state) => state.selectedAddress.isSelectedAddress;

export default selectedAddressSlice.reducer;